export { unstable_generateUtilityClass as default } from '@mui/utils';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/generateUtilityClass/index.js
// module id = 908
// module chunks = 22